/** Typed client for the platform admin API (/admin/v1), used only by the admin app. */
import { createTypedClient, type ClientContext } from "./index";
import type { components, paths } from "./admin-schema";

export type { components as adminComponents, paths as adminPaths } from "./admin-schema";
export type AdminSchemas = components["schemas"];

export function createAdminClient(context: ClientContext, baseUrl?: string) {
  return createTypedClient<paths>(context, baseUrl);
}

export type AdminClient = ReturnType<typeof createAdminClient>;
